var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"book"},[_c('read-book'),_c('page-navigation'),(_vm.showModal)?_c('word-lookup-modal-v2'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }